import React, { useEffect } from "react";
import { ClipboardList } from "lucide-react";
import { useSale } from "../../../hooks/sale/useSale";
import PendingSaleModal from "../../../pages/Sale/history/PendingSaleModal";
import { useBranch } from "../../../hooks/branches/useBranch";

/**
 * 🧾 Botón “Ventas Pendientes”
 *
 * 🔹 Muestra la cantidad actual de ventas pendientes.
 * 🔹 Al hacer clic, abre el modal <PendingSaleModal />.
 * 🔹 Carga también las sucursales con useBranch().
 */
const PendingSalesButton: React.FC = () => {
  const {
    handlerGetPendingCount,
    pendingSaleCount,
    openPendingSaleModal,
    closePendingSaleModal,
    showPendingSaleModal,
    pendingSaleList,
  } = useSale();

  const { fetchBranchDropdown, branchDropdown } = useBranch(); // ✅ Hook para sucursales

  // 🚀 Al montar: obtener número de pendientes y sucursales
  useEffect(() => {
    handlerGetPendingCount();
    fetchBranchDropdown(); // ✅ Cargar sucursales para el modal
  }, []);

  return (
    <>
      {/* 🧾 Botón principal */}
      <button
        type="button"
        onClick={openPendingSaleModal} // ✅ abrir modal
        className="flex items-center justify-center gap-2 rounded bg-primary px-4.5 py-2.5 text-sm font-medium text-white hover:bg-opacity-90 transition"
      >
        <ClipboardList className="h-4 w-4" />
        <span className="text-center leading-tight">Ventas Pendientes</span>

        {/* 🔹 Contador dinámico */}
        <span className="ml-2 rounded-full bg-white bg-opacity-20 px-2 py-0.5 text-xs font-semibold">
          {pendingSaleCount ?? 0}
        </span>
      </button>

      {/* 🪟 Modal de ventas pendientes */}
      <PendingSaleModal
        isOpen={showPendingSaleModal}
        onClose={closePendingSaleModal}
        sales={pendingSaleList}
        branches={branchDropdown}
      />
    </>
  );
};

export default PendingSalesButton;
